<template>
  <div class="commponent--playing-symbol">
    <i class="stick" :style="{ background:color }"></i>
    <i class="stick" :style="{ background:color }"></i>
    <i class="stick" :style="{ background:color }"></i>
    <i class="stick" :style="{ background:color }"></i>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style lang="scss">
.commponent--playing-symbol {
  @keyframes is-playing {
    0% {
      transform: scaleY(0.2);
    }

    100% {
      transform: scaleY(1);
    }
  }

  display: inline-block;

  i.stick {
    display: inline-block;
    width: 2px;
    height: 12px;
    margin-right: 3px;
    background: white;
    animation: is-playing 0.5s ease infinite alternate;
    transform-origin: bottom;
    vertical-align: middle;

    &:nth-child(1) {
      animation-delay: 0.15s;
    }
    &:nth-child(2) {
      animation-delay: 0.3s;
    }
    &:nth-child(3) {
      animation-delay: 0.45s;
    }
    &:nth-child(4) {
      animation-delay: 0.6s;
      margin-right: 0;
    }
  }
}
</style>